import { Button, Config, Message, Tooltip } from 'primevue';
import Ripple from 'primevue/ripple';
import { createApp } from 'vue';
import i18nConfiguration from '@app/i18n-configuration';
import primeVueConfiguration from '@app/prime-vue-configuration';
import Login from './login.vue';

const app = createApp(Login, {
    countryList: JSON.parse(document.getElementById('countryList')?.getAttribute('value') ?? '[]'),
    enterpriseCompanyName: document.getElementById('enterpriseCompanyName')?.getAttribute('value'),
    enterpriseLink: document.getElementById('enterpriseLink')?.getAttribute('value'),
    enterpriseLogo: document.getElementById('enterpriseLogo')?.getAttribute('value'),
    isEnterprise: document.getElementById('isEnterprise')?.getAttribute('value') === 'true',
    isMultiSSO: document.getElementById('isMultiSSO')?.getAttribute('value') === 'true',
    ssoServers: JSON.parse(document.getElementById('ssoServers')?.getAttribute('value') ?? '[]'),
    supportEmailAddress: document.getElementById('supportEmailAddress')?.getAttribute('value'),
    websiteMarketing: document.getElementById('websiteMarketing')?.getAttribute('value'),
    websiteSupport: document.getElementById('websiteSupport')?.getAttribute('value')
});
app.use(i18nConfiguration);
app.use(Config, primeVueConfiguration);

app.component('Button', Button);
app.component('Message', Message);

app.directive('ripple', Ripple);
app.directive('tooltip', Tooltip);

app.mount('#login');
